import { Clientexdel, IClientexdel, IPuntoServicio } from "@/entities";

export class PuntoServicio implements IPuntoServicio {
  clientexdel: IClientexdel;
  codPuntoservicio: string;
  desPuntoservicio: string;
  id: number;

  constructor() {
    this.clientexdel = new Clientexdel();
    this.codPuntoservicio = "";
    this.desPuntoservicio = "";
    this.id = 0;
  }
}
